import { router } from '@/router'

import { factoryDashboardRoutes } from './router/factory-dashboard-routes'

export function appendFactoryDashboardRoutes() {
  for (const route of factoryDashboardRoutes) {
    // const l = router.resolve({ path: log.path })
    if (!router.hasRoute(route.name as string)) {
      console.log('[appendFactoryDashboardRoutes] FactoryDashboard installRouter')
      router.addRoute(route)
    }
  }
}
